module.exports = __webpack_public_path__ + "static/media/twitter-share.aa25522c.png";